import axios from 'axios';

const timeoutSeconds = 10

export const axiosInstanceFgts = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: timeoutSeconds*1000,
});

// export default axiosInstanceFgts;

export const axiosInstanceConsignado = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL_CONSIGNADO_TRABALHADOR,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: timeoutSeconds*1000,
});

// export default [axiosInstanceFgts, axiosInstanceConsignado];
